export default "__VITE_ASSET__BZegOHGP__"